import { Mouse } from './Mouse';
import { Keyboard } from './Keyboard';

export class InputSystem {
  readonly mouse: Mouse;
  readonly keyboard: Keyboard;

  constructor(mouse: Mouse, keyboard: Keyboard) {
    this.mouse = mouse;
    this.keyboard = keyboard;
  }
}
